import type { FunctionComponent } from 'react';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { spacingHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import type {
  DynamicContents,
  DynamicContentsItem,
} from '../../../../../app-kit/components/DynamicContent/types';
import { DynamicContent } from '../../../../../app-kit/components/DynamicContent/DynamicContent';
import styled from 'styled-components';
import { trackDisclaimerModalOpen } from '../../../../../analytics/event-tracking/trackDisclaimerModalOpen';

import { usePropertyPageModalContext } from '../../../../contexts/PropertyPageModalContext/PropertyPageModalContext';
import type { SupplyDemandAndPerformanceGraph } from '../SupplyDemandAndPerformanceBrickGraph/types';
import { DisclaimerIcon } from '../../../../../app-kit/components/DisclaimerIcon/DisclaimerIcon';
import {
  EmptySupplyDemandAndPerformanceBrickGraph,
  SupplyDemandAndPerformanceBrickGraph,
} from '../SupplyDemandAndPerformanceBrickGraph/SupplyDemandAndPerformanceBrickGraph';

const TitleText = styled(Text)`
  ${typographyHelper('subtitle02')};
`;

const SubtitleWrapper = styled.div`
  ${typographyHelper('body01')}
  margin-top: ${spacingHelper('small')}
`;

interface SupplyDemandAndPerformanceBrick {
  title: string;
  subtitle: DynamicContents<DynamicContentsItem>;
  className?: string;
  graph: SupplyDemandAndPerformanceGraph;
  renderGraph?: boolean;
}

export const SupplyDemandAndPerformanceBrick: FunctionComponent<
  SupplyDemandAndPerformanceBrick
> = ({ title, subtitle, className, graph, renderGraph }) => {
  const { displayModal } = usePropertyPageModalContext();
  return (
    <ContentBrick
      titleComponent={<TitleText as="h3">{title}</TitleText>}
      subtitleComponent={
        <SubtitleWrapper>
          <DynamicContent dynamicContents={subtitle} textColorVariant="textSecondary" />
        </SubtitleWrapper>
      }
      isSubBrick={true}
      className={className}
      headerChildren={
        <DisclaimerIcon
          title="Open Supply, Demand and Performance Disclaimer"
          onClick={() => {
            displayModal({ name: 'supplyDemandPerformanceDisclaimer' });
            trackDisclaimerModalOpen({
              inPageSource: 'property_page__supply_demand_performance_brick___disclaimer_link',
            });
          }}
        />
      }
    >
      {renderGraph ? (
        <SupplyDemandAndPerformanceBrickGraph graph={graph} title={title} />
      ) : (
        <EmptySupplyDemandAndPerformanceBrickGraph />
      )}
    </ContentBrick>
  );
};
